// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var Advert = "Advert-module--Advert--2Tfxl";
export var Advert__ad_size_wrapper = "Advert-module--Advert__ad_size_wrapper--3SJLh";
export var Advert__title = "Advert-module--Advert__title--3aJG4";
export var Advert__mpu = "Advert-module--Advert__mpu--3mgIS";
export var Advert__leaderboard = "Advert-module--Advert__leaderboard--1MvOF";
export var Advert__billboard = "Advert-module--Advert__billboard--iz5oj";